import { useEffect, useState } from 'react'
import { autorun } from 'mobx'

import type { BreakpointValue } from '../themes/breakpoints'
import { breakpoints } from '../themes/breakpoints'
import { getCurrentBreakpoint } from '../utils/setCSSCustomProperty'

import { useBrandStore } from './useBrandTheme'

export function useBreakpointIndex() {
  const [br, setBr] = useState(() => getCurrentBreakpoint())
  const branding = useBrandStore()
  useEffect(
    () => autorun(() => setBr(branding.currentBreakpointIndex)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )
  return br
}

export function useBreakpointValue(): BreakpointValue {
  const breakpointIndex = useBreakpointIndex() - 1
  return breakpointIndex >= 0 ? breakpoints[breakpointIndex] : 'base'
}
